document.addEventListener('DOMContentLoaded', function () {
  const filterForms = document.querySelectorAll('.custom-filter-form');

  filterForms.forEach(function (filterForm) {
    filterForm.addEventListener('submit', function (e) {
      e.preventDefault();

      const bedroomSelect = filterForm.querySelector('#bedrooms');
      const bathroomSelect = filterForm.querySelector('#bathrooms');
      const sqftMin = filterForm.querySelector('#sq-ft-min');
      const sqftMax = filterForm.querySelector('#sq-ft-max');

      const searchParams = new URLSearchParams();

      if (bedroomSelect && bedroomSelect.value) {
        searchParams.append('filter.p.tag', bedroomSelect.value);
      }

      if (bathroomSelect && bathroomSelect.value) {
        const bathValue = bathroomSelect.value.replace(/-/g, '.');
        searchParams.append('filter.p.tag', bathValue);
      }

      if (sqftMin && sqftMin.value) {
        searchParams.append('filter.p.sqft_min', sqftMin.value);
      }
      if (sqftMax && sqftMax.value) {
        searchParams.append('filter.p.sqft_max', sqftMax.value);
      }

      // Redirect to the filtered URL
      window.location.href = `${filterForm.action}?${searchParams.toString()}`;
    });
  });

  // Check if the URL contains filter parameters and trigger loading all results
  const urlParams = new URLSearchParams(window.location.search);
  const hasFilters = urlParams.has('filter.p.tag') || urlParams.has('filter.p.sqft_min') || urlParams.has('filter.p.sqft_max');

  if (hasFilters) {
    // Reset the load-more component to ensure fresh state
    const loadMoreElement = document.querySelector('load-more');
    if (loadMoreElement) {
      loadMoreElement.isLastPage = false;
      loadMoreElement.setAttribute('page-url', window.location.href); // Reset to current filtered URL
    }

    // Dispatch event to load all filtered results
    document.dispatchEvent(new CustomEvent('load-all-filtered-results'));
  }
});